module.exports = __webpack_public_path__ + "media/images/client-hand-stone-2-9db579dda30fb6d70f69ad149017fdfc.png";